/**
 * useFeaturedHost — Iter 67af.
 *
 * Tiny hook returning `{vendorId, weekIso}` for the platform's "featured host
 * of the week". Every consumer shares a single in-flight promise (module
 * scope) so a Browse page rendering 30 car cards fires exactly one
 * `/api/featured-host` request, not 30.
 */
import { useEffect, useState } from "react";
import api from "@/lib/api";

let _cachedPromise = null;

function _fetchOnce() {
  if (!_cachedPromise) {
    _cachedPromise = api.get("/featured-host")
      .then((r) => (r?.data?.enabled && r.data.vendor) ? {
        vendorId: r.data.vendor.vendor_id,
        weekIso: r.data.week_iso,
        vendor: r.data.vendor,
      } : { vendorId: null, weekIso: null, vendor: null })
      .catch(() => ({ vendorId: null, weekIso: null, vendor: null }));
  }
  return _cachedPromise;
}

export default function useFeaturedHost() {
  const [state, setState] = useState({ vendorId: null, weekIso: null, vendor: null });
  useEffect(() => {
    let cancelled = false;
    _fetchOnce().then((data) => {
      if (!cancelled) setState(data);
    });
    return () => { cancelled = true; };
  }, []);
  return state;
}
